

export default {
  SET_PRODUCTS(state, payload) {
    state.items = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/products/mutations.js